import { DELETE_MICROSCOPY_ANNOTATIONS } from '@custom/constant';
import { createAsyncThunk } from '@reduxjs/toolkit';


const deleteMicroscopyAnnotation = createAsyncThunk('deleteMicroscopyAnnotation', async (formData:FormData) => {
  try {
    const token = sessionStorage.getItem('token') || localStorage.getItem('token');
    let url = DELETE_MICROSCOPY_ANNOTATIONS
    let response = await fetch(url, {
      method: 'DELETE',
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: formData
    })
    return await response.json()
  } catch (error) {
    return error;
  }
});

export default deleteMicroscopyAnnotation;
